export const BaseRoutesName = {
    JoinGroup: 'JoinGroup',
    LeaveGroup: 'LeaveGroup',
};
